import { searchItems } from '@sbt-web/network/client';
import type { SearchResult } from '@sbt-web/network/types';
import { PROFILE_ADS_PER_PAGE } from '@/shared/constants';

export const getUserAds = async (
  userId: string,
  isPro: boolean = false,
  showProAds: boolean = false,
  start?: number,
  lim: number = PROFILE_ADS_PER_PAGE
): Promise<SearchResult> => {
  const { body } = await searchItems(
    process.env.ANUBI_BASE_URL || process.env.NEXT_PUBLIC_HADES_BASE_URL,
    {
      uid: userId,
      lim,
      start,
      ...(isPro && !showProAds && { advt: '0,2' }),
    },
    undefined,
    true
  );

  return body;
};
